import { render } from "./CommonArea.vue?vue&type=template&id=0242d456&scoped=true"
import script from "./CommonArea.vue?vue&type=script&lang=js"
export * from "./CommonArea.vue?vue&type=script&lang=js"

import "./CommonArea.vue?vue&type=style&index=0&id=0242d456&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0242d456"

export default script